// src/components/MenuItems/links.tsx
import { ReactComponent as IconAssistant } from "../../assets/img/icons/icon_JusticeAssist.svg";
import { ReactComponent as IconAssistantAI } from "../../assets/img/icons/ai-assistant.svg";
import { ReactComponent as IconCNI } from "../../assets/img/icons/icon_CNI.svg";
import { ReactComponent as IconDarkWeb } from "../../assets/img/icons/icon_Thief.svg";
import { ReactComponent as IconDashboard } from "../../assets/img/icons/icon_dashboard.svg";
import { ReactComponent as IconDatabase } from "../../assets/img/icons/icon_Database.svg";
import { ReactComponent as IconStats } from "../../assets/img/icons/icon_stats.svg";
import { ReactComponent as IconBell } from "../../assets/img/icons/icon_bell.svg";
import { ReactComponent as IconFolder } from "../../assets/img/icons/icon_folder.svg";
import { ReactComponent as IconLock } from "../../assets/img/icons/icon_Lock.svg";
import { ReactComponent as IconVerification } from "../../assets/img/icons/icon_Verify.svg";
import { ReactComponent as IconSignalement } from "../../assets/img/icons/icon_add_database.svg";
import { ReactComponent as IconDiagnostic } from "../../assets/img/icons/Verification/Icons.svg";
import { ReactComponent as IconIDPay } from "../../assets/img/icons/Verification/Icons.svg";
const iconProps = {
    fill: "#fff",
    width: "24px",
};

const links = [
    {
        url: "dashboard",
        label: "Tableau de bord",
        icon: <IconDashboard {...iconProps} />,
        hideInPartner: false,
        hideIfUnverified: false,
        hideInIndividual: true,
        hideIfADV: true,
        hideIfSofinco: true,
    },
    {
        url: "pieces-identite",
        label: "ID Tracker",
        icon: <IconCNI {...iconProps} />,
        hideInPartner: true,
        hideIfUnverified: false,
        hideIfADV: true,
        hideIfSofinco: true,
    },
    {
        url: "filter",
        label: "Filigrane",
        icon: <IconLock {...iconProps} />,
        hideInPartner: false,
        hideIfUnverified: false,
        hideIfADV: true,
        hideIfSofinco: false,
    },
    {
        url: "verifier-document",
        label: "ID Verify",
        icon: <IconVerification {...iconProps} />,
        hideInPartner: false,
        hideIfUnverified: false,
        hideIfADV: false,
        hideIfSofinco: true,
    },
    {
        url: "dark-web",
        label: "Dark Web",
        icon: <IconDarkWeb {...iconProps} />,
        hideInPartner: false,
        hideInIndividual: true,
        hideIfUnverified: false,
        hideIfADV: true,
        hideIfSofinco: true,
    },
    {
        url: "base-de-donnees",
        label: "ID Database",
        icon: <IconDatabase {...iconProps} />,
        hideInPartner: false,
        hideInIndividual: true,
        hideIfUnverified: false,
        hideIfADV: false,
        hideIfSofinco: false,
    },
    {
        url: "id-locker",
        label: "ID Locker",
        icon: <IconFolder {...iconProps} />,
        hideInPartner: false,
        hideInIndividual: false,
        hideIfUnverified: false,
        hideIfADV: false,
        hideIfSofinco: true,
    },
    /*{
        url: "id-locker/creer_dossier",
        label: "ID Locker",
        icon: <IconFolder {...iconProps} />,
        hideInPartner: false,
        hideInIndividual: false,
        hideIfUnverified: false,
        hideIfADV: false,
    },*/
    /*{
        url: "fraud/leboncoin",
        label: "Vérif. Leboncoin",
        icon: <IconVerification {...iconProps} />,
        hideInPartner: true,
        hideInIndividual: false,
        hideIfUnverified: false,
        hideIfADV: true,
    },*/

    // On a caché ID Assistant car, par encore finit l'implementation
    {
        url: "id-assistant",
        label: "ID Assistant",
        icon: <IconAssistant {...iconProps} />,
        hideInPartner: true,
        hideIfnotSub: false,
        hideIfUnverified: false,
        hideIfADV: true,
        hideIfSofinco: true,
    },
    {
        url: "id-assistant-ai",
        label: "ID Assistant IA",
        icon: <IconAssistantAI {...iconProps} />,
        hideIfnotSub: true,
        hideInPartner: true,
        hideIfUnverified: false,
        hideIfADV: true,
        hideIfSofinco: true,
    },
    /*{
        url: "id-pay/dashboard",
        label: "ID Pay",
        icon: <IconIDPay {...iconProps} />,
        hideInPartner: true,
        hideIfUnverified: false,
    },*/
    {
        url: "signaler-document",
        label: "Signalement",
        icon: <IconSignalement {...iconProps} />,
        hideInPartner: false,
        hideInIndividual: true,
        hideIfUnverified: false,
        hideIfADV: true,
        // Réservé aux administrateurs du partenaire : un collaborateur "member"
        // ne voit pas le signalement (la route est gardée par PartnerAdminRoute).
        hideInPartnerMember: true,
        hideIfSofinco: false,
    },
    {
        url: "doc-request-stats",
        label: "Stats",
        icon: <IconStats {...iconProps} />,
        hideInPartner: false,
        hideInIndividual: true,
        hideIfUnverified: false,
        hideIfADV: false,
        hideInPartnerMember: true,
        hideIfSofinco: false,
    },
    {
        url: "notifications",
        label: "Notifications",
        icon: <IconBell {...iconProps} />,
        hideInPartner: false,
        hideInIndividual: false,
        showInMobile: true,
        showInDesktop: false,
        hideIfUnverified: false,
        hideIfADV: true,
        isNotification: true,
        hideIfSofinco: true,
    },
    /*{
        url: "diagnostic",
        label: "Diagnostic",
        icon: <IconDiagnostic {...iconProps} />,
        hideInPartner: true,
        hideIfUnverified: false,
        hideIfADV: true,
        hideIfSofinco: true,
    },*/

];

export default links;
